<template>
  <div class="loading" v-if="!isFinish" :class='showRotateTips ? "hos-loading": ""'>
    <header>
      <img class="report-logo" src="@/assets/images/year-review/review-logo@2x.png">
    </header>
    <div class="content">
      <svg viewBox="25 25 50 50" class="circular">
        <circle cx="50" cy="50" r="20" fill="none" class="path" />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isFinish: {
      default() {
        return true
      },
      required: true
    },
    bgcolor: {
      default(){
        return '#fff'
      },
      required: false,
      type: String
    },
    showRotateTips:Boolean
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/rem.scss';
$rem: 66.7px;
html{
  font-size: $rem;
}
@function remHos($px) {
  @return $px / $rem * 1rem;
}
.loading {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 99999999;
  background: #fff url('../../../assets/images/year-review/review-bg@2x.png') no-repeat center;
  background-size:cover; 
}
.report-logo{
  padding: 0 rem(25px);
  height: rem(18px);
}
.content{
  flex:1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.circular {
  height: rem(42px);
  width: rem(42px);
  animation: loading-rotate 2s linear infinite;
  margin-top: rem(-60px);
}
.path {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: #409eff;
  stroke-linecap: round;
}
.hos-loading{
  .report-logo{
    padding: 0 remHos(25px);
    height: remHos(18px);
  }
  .circular {
    height: remHos(42px);
    width: remHos(42px);
    margin-top: remHos(-60px);
  }
}
@keyframes loading-rotate {
  100% {
    transform: rotate(1turn);
  }
}
</style>